import { useTranslation } from "react-i18next"
import { Accordion, type AccordionItemType, HelpWidgetPanel } from "ui"

export const TranslatedAccordion = ({
  translationKeys,
  className,
}: {
  translationKeys: HelpWidgetPanel
  className?: string
}) => {
  const { t } = useTranslation(["map", "facets", "data"])

  const items: AccordionItemType[] = translationKeys.accordionItems.map(
    (category: AccordionItemType) => ({
      title: <p className="text-title font-semibold text-black">{t(category.title as string)}</p>,
      type: "accordion",
      nestedAccordionContent: category.nestedAccordionContent!.map((item) => ({
        content: t(item.content as string),
        title: (
          <p className="pr-4 text-left text-body font-medium text-brand-green-dark">
            {t(item.title as string)}
          </p>
        ),
      })),
    })
  )

  return (
    <Accordion
      items={items}
      variant="primary"
      className={`border-b-2 border-brand-green py-5 ${className}`}
    />
  )
}
